import { render } from "./CustomDataTable.vue?vue&type=template&id=088b05fe&scoped=true"
import script from "./CustomDataTable.vue?vue&type=script&lang=js"
export * from "./CustomDataTable.vue?vue&type=script&lang=js"

import "./CustomDataTable.vue?vue&type=style&index=0&id=088b05fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-088b05fe"]])

export default __exports__